module.exports = __webpack_public_path__ + "media/icons/envelope-2023ccbd.png";